import TeacherProfileHeader from './TeacherProfileHeader.component';

export default TeacherProfileHeader;